/**
 * save-data-export-schema-request.ts
 * Copyright (c) 2016-2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message } from "../general/message";
import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class SaveDataExportSchemaRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_SAVE_DATA_EXPORT_SCHEMA;
	public static tag : MessageTag = MessageTag.REQ_SAVE_DATA_EXPORT_SCHEMA;

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_SAVE_REPORT_SCHEMA);
  }

  constructor (
    public exportId : number,
    public schemaName : string,
		public isGroupPublic : boolean = false,
		public exportFilename : string = ""
  )
  {
    super();
  }

}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/schemas/save-data-export-schema-request.ts